import * as XLSX from 'xlsx';

export const SABLON_URL =
  'https://cloud3.okta.rs:20020/Templates/UnosDelova_template.xlsx';

const MAKS_DUZINA = { naziv: 50, partNumber: 100, opis: 200 };

const KOLONE = {
  naziv: ['naziv', 'name'],
  partNumber: ['brojdela', 'partnumber'],
  opis: ['opis', 'description'],
  masina: ['masinasifra', 'masina', 'machine'],
  kategorija: ['kategorija', 'partcategoryname', 'category'],
  nabavnaCena: ['nabavnacena'],
  marza: ['marza', 'marzaprocenat'],
  prodajnaCena: ['prodajnacena'],
  favorit: ['favorit'],
  akcija: ['akcija'],
  prikazNaShopu: ['prikazuprodavnici', 'prikaznashopu'],
};

const normalizuj = (vrednost) =>
  String(vrednost ?? '')
    .toLowerCase()
    .replace(/đ/g, 'dj')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]/g, '');

const tekst = (vrednost) => String(vrednost ?? '').trim();
const zaokruzi = (broj) => Math.round(broj * 100) / 100;

const procitajBroj = (vrednost) => {
  if (vrednost === null || vrednost === undefined || tekst(vrednost) === '') {
    return { broj: null };
  }
  if (typeof vrednost === 'number') return { broj: vrednost };
  const broj = Number(tekst(vrednost).replace(/\s/g, '').replace(',', '.'));
  return Number.isNaN(broj) ? { greska: true } : { broj };
};

const DA = ['da', 'yes', 'true', '1', 'x'];
const NE = ['ne', 'no', 'false', '0'];
const procitajDaNe = (vrednost, podrazumevano) => {
  const norm = normalizuj(vrednost);
  if (!norm) return { vrednost: podrazumevano };
  if (DA.includes(norm)) return { vrednost: true };
  if (NE.includes(norm)) return { vrednost: false };
  return { greska: true };
};

const nadjiMasinu = (sifra, masine) => {
  const trazeno = tekst(sifra).toLowerCase();
  return masine.find((masina) => {
    const naziv = tekst(masina.vrednost).toLowerCase();
    return naziv === trazeno || naziv.startsWith(`${trazeno} `);
  });
};

const nadjiKategoriju = (naziv, kategorije) =>
  kategorije.find(
    (kategorija) =>
      tekst(kategorija.vrednost).toLowerCase() === tekst(naziv).toLowerCase(),
  );

const mapaKolona = (zaglavlje) =>
  Object.entries(KOLONE).reduce((acc, [polje, nazivi]) => {
    const indeks = zaglavlje.findIndex((naziv) =>
      nazivi.includes(normalizuj(naziv)),
    );
    return indeks >= 0 ? { ...acc, [polje]: indeks } : acc;
  }, {});

const obradiRed = (vrednosti, kolone, liste, vidjeniBrojevi) => {
  const uzmi = (polje) =>
    kolone[polje] === undefined ? '' : vrednosti[kolone[polje]];
  const greske = [];

  const naziv = tekst(uzmi('naziv'));
  const partNumber = tekst(uzmi('partNumber'));
  const opis = tekst(uzmi('opis'));
  if (!naziv) greske.push('Naziv je obavezan.');
  Object.entries({ naziv, partNumber, opis }).forEach(([polje, vrednost]) => {
    if (vrednost.length > MAKS_DUZINA[polje]) {
      greske.push(
        `Polje „${polje}“ ima više od ${MAKS_DUZINA[polje]} karaktera.`,
      );
    }
  });

  const brojDelaNorm = partNumber.toLowerCase();
  if (brojDelaNorm && vidjeniBrojevi.has(brojDelaNorm)) {
    greske.push(`Deo sa brojem „${partNumber}“ već postoji.`);
  }

  let masina = null;
  if (tekst(uzmi('masina'))) {
    masina = nadjiMasinu(uzmi('masina'), liste.masine);
    if (!masina) greske.push(`Mašina „${tekst(uzmi('masina'))}“ ne postoji.`);
  }
  let kategorija = null;
  if (tekst(uzmi('kategorija'))) {
    kategorija = nadjiKategoriju(uzmi('kategorija'), liste.kategorije);
    if (!kategorija) {
      greske.push(`Kategorija „${tekst(uzmi('kategorija'))}“ ne postoji.`);
    }
  }

  const nabavna = procitajBroj(uzmi('nabavnaCena'));
  const marzaUneta = procitajBroj(uzmi('marza'));
  const prodajna = procitajBroj(uzmi('prodajnaCena'));
  if (nabavna.greska) greske.push('Nabavna cena nije broj.');
  if (marzaUneta.greska) greske.push('Marža nije broj.');
  if (prodajna.greska) greske.push('Prodajna cena nije broj.');
  if ([nabavna.broj, marzaUneta.broj, prodajna.broj].some((b) => b < 0)) {
    greske.push('Cene i marža ne mogu biti manje od 0.');
  }

  let marza = marzaUneta.broj;
  let prodajnaCena = prodajna.broj;
  const marzaKategorije =
    kategorija?.marza !== null && kategorija?.marza !== undefined
      ? Number(kategorija.marza)
      : null;
  if (prodajnaCena === null && nabavna.broj !== null) {
    const primenjenaMarza = marza ?? marzaKategorije;
    if (primenjenaMarza === null) {
      greske.push(
        'Unesite prodajnu cenu ili maržu (ili kategoriju sa maržom).',
      );
    } else {
      prodajnaCena = zaokruzi(nabavna.broj * (1 + primenjenaMarza / 100));
    }
  } else if (prodajnaCena !== null && marza === null && nabavna.broj > 0) {
    marza = zaokruzi((prodajnaCena / nabavna.broj - 1) * 100);
  }

  const favorit = procitajDaNe(uzmi('favorit'), false);
  const akcija = procitajDaNe(uzmi('akcija'), false);
  const prikazNaShopu = procitajDaNe(uzmi('prikazNaShopu'), true);
  if (favorit.greska) greske.push('Favorit mora biti DA ili NE.');
  if (akcija.greska) greske.push('Akcija mora biti DA ili NE.');
  if (prikazNaShopu.greska) {
    greske.push('Prikaz u prodavnici mora biti DA ili NE.');
  }

  if (/^primer\s*-/i.test(naziv)) {
    greske.splice(0, greske.length, 'Primer red iz šablona – ne uvozi se.');
  }
  if (brojDelaNorm && !greske.length) vidjeniBrojevi.add(brojDelaNorm);

  return {
    greske,
    deo: {
      naziv,
      partNumber,
      opis,
      idMasine: masina?.id || null,
      nazivMasine: masina?.vrednost || '',
      idKategorijeDela: kategorija?.id || null,
      nazivKategorije: kategorija?.vrednost || '',
      nabavnaCena: nabavna.broj ?? 0,
      marza,
      prodajnaCena: prodajnaCena ?? 0,
      favorit: favorit.vrednost,
      akcija: akcija.vrednost,
      prikazNaShopu: prikazNaShopu.vrednost,
    },
  };
};

// liste: { masine, kategorije, postojeciDelovi } – postojeći delovi služe za proveru duplikata po broju dela
export const procitajExcelDelova = async (fajl, liste) => {
  const knjiga = XLSX.read(await fajl.arrayBuffer(), { type: 'array' });
  const imeLista =
    knjiga.SheetNames.find((ime) => normalizuj(ime) === 'delovi') ||
    knjiga.SheetNames[0];
  const list = knjiga.Sheets[imeLista];
  if (!list?.['!ref']) throw new Error('Excel fajl je prazan.');
  const prviRed = XLSX.utils.decode_range(list['!ref']).s.r;
  const redovi = XLSX.utils.sheet_to_json(list, {
    header: 1,
    defval: '',
    blankrows: true,
  });
  if (!redovi.length) throw new Error('Excel fajl je prazan.');

  const kolone = mapaKolona(redovi[0]);
  if (kolone.naziv === undefined) {
    throw new Error(
      'U prvom redu nije pronađena kolona „Naziv“. Koristite šablon za uvoz.',
    );
  }

  const vidjeniBrojevi = new Set(
    (liste.postojeciDelovi || [])
      .map((deo) => tekst(deo.partNumber).toLowerCase())
      .filter(Boolean),
  );

  return redovi
    .map((vrednosti, indeks) => ({
      vrednosti,
      brojReda: prviRed + indeks + 1,
    }))
    .slice(1)
    .filter(({ vrednosti }) => vrednosti.some((v) => tekst(v) !== ''))
    .map(({ vrednosti, brojReda }) => ({
      brojReda,
      ...obradiRed(vrednosti, kolone, liste, vidjeniBrojevi),
    }));
};

export const formDataDela = (deo) => {
  const fd = new FormData();
  fd.append('id', 0);
  fd.append('naziv', deo.naziv);
  fd.append('opis', deo.opis);
  fd.append('partNumber', deo.partNumber);
  fd.append('IdKorProm', +localStorage.idKorisnika);
  fd.append('nabavnaCena', deo.nabavnaCena);
  if (deo.marza !== null) fd.append('marza', deo.marza);
  fd.append('prodajnaCena', deo.prodajnaCena);
  if (deo.idKategorijeDela) fd.append('idKategorijeDela', deo.idKategorijeDela);
  fd.append('favorit', deo.favorit);
  fd.append('akcija', deo.akcija);
  fd.append('prikazNaShopu', deo.prikazNaShopu);
  if (deo.idMasine) fd.append('idMasine', deo.idMasine);
  return fd;
};
